import { isWindowDefined } from "@huub-web/utils";

import type { GTMEventData } from "../types";

// Global variable to track current data layer name
let currDataLayerName = "dataLayer";

/**
 * Set the current data layer name (used internally by GTM component)
 */
export const setCurrDataLayerName = (name: string): void => {
  currDataLayerName = name;
};

/**
 * Send custom events to Google Tag Manager
 * Works in both Next.js and Vite environments
 */
export const sendGTMEvent = (
  data: GTMEventData,
  dataLayerName?: string,
): void => {
  if (!isWindowDefined()) {
    console.warn("[GTM] sendGTMEvent called on server side");
    return;
  }

  // Use provided dataLayerName or fall back to current global dataLayerName
  const targetDataLayer = dataLayerName || currDataLayerName;

  // Initialize dataLayer if it doesn't exist
  if (!window[targetDataLayer]) {
    window[targetDataLayer] = [];
  }

  // Push event data to dataLayer
  window[targetDataLayer].push(data);

  console.log(`[GTM] Event sent to ${targetDataLayer}:`, data);
};
